export default [
    {
        path: 'lancamento',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-lancamento' */
            '@/views/exame-imagem/lancamento/Index'
        ),
        redirect: 'lancamento/index',
        children: [
            {
                name: 'exame-imagem-lancamento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-lancamento' */
                    '@/views/exame-imagem/lancamento/List.vue'
                ),
            },
            {
                name: 'exame-imagem-lancamento-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-lancamento' */
                    '@/views/exame-imagem/lancamento/Form.vue'
                ),
            },
            {
                name: 'exame-imagem-lancamento-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-lancamento' */
                    '@/views/exame-imagem/lancamento/Form.vue'
                ),
            },
        ],
    },
]